import { useRouter } from 'next/router'
import React, { useState, useEffect } from 'react'
import FormField from '../../../../atoms/FormField/FormField'
import FormInput from '../../../../atoms/FormInput/FormInput'
import FormSelect from '../../../../atoms/FormSelect/FormSelect'
import Button from '../../../../atoms/Button/Button'
import useTrans from '../../../../../hooks/useTrans'
import { NAZIONI, PROVINCE } from '../../../../../utils/endpoint'
import { api } from '../../../../../utils/index'
import {
  getVisibleFields,
  getRequiredFields,
  isStepRequired,
  hasDifferentRequiredFieldsIndirizzoFatturazione,
} from '../../../../../utils/servicegift'
import { useSelector } from 'react-redux'
import FormCheckbox from '../../../../atoms/FormCheckbox/FormCheckbox'

const DatiSpedizioneFatturazione = ({ step, setStep, props }) => {
  const { service_gift } = useSelector((state) => state?.servicegift)
  const router = useRouter()
  const t = useTrans()

  const visibleFields = getVisibleFields(service_gift, props.values.utente.tipologia, 'checkout')
  const requiredFields = getRequiredFields(service_gift, props.values.utente.tipologia, 'checkout')
  const [nazioni, setNazioni] = useState([])
  const [province, setProvince] = useState([])

  const isSpedizioneDiversa = isStepRequired(
    service_gift,
    props.values.utente.tipologia,
    'checkout',
    'indirizzi_diversi'
  )
  const isFatturaRichiesta = isStepRequired(
    service_gift,
    props.values.utente.tipologia,
    'checkout',
    'fattura_richiesta'
  )
  const hasDifferentRequiredFieldsIndirizzi = hasDifferentRequiredFieldsIndirizzoFatturazione(
    service_gift,
    props.values.utente.tipologia
  )

  useEffect( () => {
    !props.values.dati_indirizzo_spedizione?.email &&
      props.setFieldValue('dati_indirizzo_spedizione.email', props.values.utente.username)
    !props.values.email_spedizione &&
      props.setFieldValue('email_spedizione', props.values.utente.username)
    !props.values.dati_indirizzo_spedizione?.nome &&
      props.setFieldValue('dati_indirizzo_spedizione.nome', props.values.utente.nome)
    !props.values.dati_indirizzo_spedizione?.cognome &&
      props.setFieldValue('dati_indirizzo_spedizione.cognome', props.values.utente.cognome)
    !props.values.dati_indirizzo_spedizione?.telefono &&
      props.setFieldValue('dati_indirizzo_spedizione.telefono', props.values.utente.telefono)

    /* !props.values.dati_indirizzo_spedizione?.ragione_sociale &&
      props.setFieldValue('dati_indirizzo_spedizione.ragione_sociale', props.values.dati_aziendali.ragione_sociale)
    !props.values.dati_indirizzo_spedizione?.partita_iva &&
      props.setFieldValue('dati_indirizzo_spedizione.partita_iva', props.values.dati_aziendali.partita_iva) */

    api
      .get(NAZIONI, { params: { lang: router.locale } })
      .then((result_nazioni) => setNazioni(result_nazioni.data))
    api.get(PROVINCE).then((result_province) => setProvince(result_province?.data))
    
  }, [])

  useEffect(() => {
    if (props.values.indirizzi_diversi && props.values.fattura_richiesta) {
      !props.values.dati_indirizzo?.email &&
        props.setFieldValue(
          'dati_indirizzo.email',
          props.values.dati_indirizzo_spedizione?.email || props.values.utente.username
        )
      !props.values.dati_indirizzo?.nome &&
        props.setFieldValue(
          'dati_indirizzo.nome',
          props.values.dati_indirizzo_spedizione?.nome || props.values.utente.nome
        )
      !props.values.dati_indirizzo?.cognome &&
        props.setFieldValue(
          'dati_indirizzo.cognome',
          props.values.dati_indirizzo_spedizione?.cognome || props.values.utente.cognome
        )
      !props.values.dati_indirizzo?.telefono &&
        props.setFieldValue(
          'dati_indirizzo.telefono',
          props.values.dati_indirizzo_spedizione?.telefono || props.values.utente.telefono
        )
    } else {
      props.setFieldValue('dati_indirizzo', {})
    }
  }, [props.values.indirizzi_diversi, props.values.fattura_richiesta])

  useEffect(() => {
    if (!props.values.fattura_richiesta) {
      props.setFieldValue('dati_indirizzo', {})
      props.setFieldValue('indirizzi_diversi', false)
    }
  }, [props.values.fattura_richiesta])

  useEffect(() => {
    if (hasDifferentRequiredFieldsIndirizzi) {
      props.setFieldValue('indirizzi_diversi', true)
    }
  }, [hasDifferentRequiredFieldsIndirizzi])

  useEffect(() => {
    if (props.values.dati_indirizzo_spedizione?.email) {
      props.setFieldValue(
        'email_spedizione',
        props.values.dati_indirizzo_spedizione?.email || props.values.utente?.email
      )
    }
  }, [props.values.dati_indirizzo_spedizione?.email])

  return (
    <div className="step-registrazione">
      <div>
        <p className="checkout__section-title">{t('Indirizzo di consegna')}</p>
        <div className="step-registrazione__fieldsets">
          {visibleFields.includes('indirizzo_spedizione.nome') && (
            <FormField
              label={t('Nome') + (requiredFields.includes('indirizzo_spedizione.nome') ? ' *' : '')}
              status={
                props.touched.dati_indirizzo_spedizione?.nome &&
                props.errors.dati_indirizzo_spedizione?.nome
                  ? 'error'
                  : props.touched.dati_indirizzo_spedizione?.nome && 'success'
              }
              errorMessage={props.errors?.dati_indirizzo_spedizione?.nome}
              infoMessage={
                props.values.fattura_richiesta && props.values.indirizzi_diversi
                  ? t('Indica il nome del destinatario della spedizione')
                  : t(
                      "Indica il nome dell'intestatario della fattura e del destinatario della spedizione"
                    )
              }
            >
              <FormInput
                value={props.values.dati_indirizzo_spedizione.nome}
                onBlur={props.handleBlur('dati_indirizzo_spedizione.nome')}
                onChange={props.handleChange('dati_indirizzo_spedizione.nome')}
              ></FormInput>
            </FormField>
          )}
          {visibleFields.includes('indirizzo_spedizione.cognome') && (
            <FormField
              label={
                t('Cognome') + (requiredFields.includes('indirizzo_spedizione.cognome') ? ' *' : '')
              }
              status={
                props.touched.dati_indirizzo_spedizione?.cognome &&
                props.errors.dati_indirizzo_spedizione?.cognome
                  ? 'error'
                  : props.touched.dati_indirizzo_spedizione?.cognome && 'success'
              }
              errorMessage={props.errors?.dati_indirizzo_spedizione?.cognome}
              infoMessage={
                props.values.fattura_richiesta && props.values.indirizzi_diversi
                  ? t('Indica il cognome del destinatario della spedizione')
                  : t(
                      "Indica il cognome dell'intestatario della fattura e del destinatario della spedizione"
                    )
              }
            >
              <FormInput
                value={props.values.dati_indirizzo_spedizione.cognome}
                onBlur={props.handleBlur('dati_indirizzo_spedizione.cognome')}
                onChange={props.handleChange('dati_indirizzo_spedizione.cognome')}
              ></FormInput>
            </FormField>
          )}
          {visibleFields.includes('indirizzo_spedizione.ragione_sociale') && (
            <FormField
              label={
                t('Ragione Sociale') +
                (requiredFields.includes('indirizzo_spedizione.ragione_sociale') ? ' *' : '')
              }
              status={
                props.touched.dati_indirizzo_spedizione?.ragione_sociale &&
                props.errors.dati_indirizzo_spedizione?.ragione_sociale
                  ? 'error'
                  : props.touched.dati_indirizzo_spedizione?.ragione_sociale && 'success'
              }
              errorMessage={props.errors?.dati_indirizzo_spedizione?.ragione_sociale}
            >
              <FormInput
                placeholder={t('Inserisci la ragione sociale')}
                value={props.values.dati_indirizzo_spedizione?.ragione_sociale}
                onChange={props.handleChange('dati_indirizzo_spedizione.ragione_sociale')}
                onBlur={props.handleBlur('dati_indirizzo_spedizione.ragione_sociale')}
              ></FormInput>
            </FormField>
          )}
          {visibleFields.includes('indirizzo_spedizione.indirizzo') && (
            <FormField
              label={
                t('indirizzo e n° civico') +
                (requiredFields.includes('indirizzo_spedizione.indirizzo') ? ' *' : '')
              }
              status={
                props.touched.dati_indirizzo_spedizione?.indirizzo &&
                props.errors.dati_indirizzo_spedizione?.indirizzo
                  ? 'error'
                  : props.touched.dati_indirizzo_spedizione?.indirizzo && 'success'
              }
              errorMessage={props.errors?.dati_indirizzo_spedizione?.indirizzo}
            >
              <FormInput
                placeholder={t("Inserisci l'indirizzo e il n° civico")}
                value={props.values.dati_indirizzo_spedizione?.indirizzo}
                onChange={props.handleChange('dati_indirizzo_spedizione.indirizzo')}
                onBlur={props.handleBlur('dati_indirizzo_spedizione.indirizzo')}
              ></FormInput>
            </FormField>
          )}
          {visibleFields.includes('indirizzo_spedizione.citta') && (
            <FormField
              label={
                t('Citta') + (requiredFields.includes('indirizzo_spedizione.citta') ? ' *' : '')
              }
              status={
                props.touched.dati_indirizzo_spedizione?.citta &&
                props.errors.dati_indirizzo_spedizione?.citta
                  ? 'error'
                  : props.touched.dati_indirizzo_spedizione?.citta && 'success'
              }
              errorMessage={props.errors?.dati_indirizzo_spedizione?.citta}
            >
              <FormInput
                placeholder={t('Inserisci la città')}
                value={props.values.dati_indirizzo_spedizione?.citta}
                onChange={props.handleChange('dati_indirizzo_spedizione.citta')}
                onBlur={props.handleBlur('dati_indirizzo_spedizione.citta')}
              ></FormInput>
            </FormField>
          )}
          {visibleFields.includes('indirizzo_spedizione.cap') && (
            <FormField
              label={t('cap') + (requiredFields.includes('indirizzo_spedizione.cap') ? ' *' : '')}
              type="number"
              status={
                props.touched.dati_indirizzo_spedizione?.cap &&
                props.errors.dati_indirizzo_spedizione?.cap
                  ? 'error'
                  : props.touched.dati_indirizzo_spedizione?.cap && 'success'
              }
              errorMessage={props.errors?.dati_indirizzo_spedizione?.cap}
            >
              <FormInput
                placeholder={t('Inserisci il CAP')}
                value={props.values.dati_indirizzo_spedizione?.cap}
                onChange={props.handleChange('dati_indirizzo_spedizione.cap')}
                onBlur={props.handleBlur('dati_indirizzo_spedizione.cap')}
              ></FormInput>
            </FormField>
          )}
          {visibleFields.includes('indirizzo_spedizione.nazione') && (
            <FormField
              label={
                t('Paese') + (requiredFields.includes('indirizzo_spedizione.nazione') ? ' *' : '')
              }
              status={
                props.touched.dati_indirizzo_spedizione?.nazione_id &&
                props.errors.dati_indirizzo_spedizione?.nazione_id
                  ? 'error'
                  : props.touched.dati_indirizzo_spedizione?.nazione_id && 'success'
              }
              errorMessage={props.errors?.dati_indirizzo_spedizione?.nazione_id}
            >
              <FormSelect
                isSearchable={true}
                options={
                  nazioni &&
                  nazioni.map((nazione) => {
                    return {
                      label: nazione.alias,
                      value: nazione.id,
                    }
                  })
                }
                value={props.values.dati_indirizzo_spedizione?.nazione_id}
                placeholder={t('Seleziona il paese')}
                onChange={(e) => {
                  props.setFieldValue('is_spedizione_italia', e.target.label === 'Italia' ? true : false)

                  props.setFieldValue('dati_indirizzo_spedizione.provincia', null)
                  props.setFieldValue('dati_indirizzo_spedizione.sdi', null)
                  props.setFieldValue('dati_indirizzo_spedizione.pec', null)
                  props.setFieldValue('dati_indirizzo_spedizione.nazione_id', e.target.value)
                }}
                onBlur={props.handleBlur('dati_indirizzo_spedizione.nazione_id')}
              ></FormSelect>
            </FormField>
          )}
          {visibleFields.includes('indirizzo_spedizione.provincia') &&
            props?.values?.is_spedizione_italia && (
              <FormField
                label={
                  t('Provincia') +
                  (requiredFields.includes('indirizzo_spedizione.provincia') ? ' *' : '')
                }
                status={
                  props.values.dati_indirizzo_spedizione?.provincia === null
                    ? 'error'
                    : props.errors.dati_indirizzo_spedizione?.provincia
                    ? 'error'
                    : props.touched.dati_indirizzo_spedizione?.provincia && 'success'
                }
                errorMessage={props.errors?.dati_indirizzo_spedizione?.provincia}
              >
                <FormSelect
                  onBlur={props.handleBlur('dati_indirizzo_spedizione.provincia')}
                  isSearchable={true}
                  onChange={(e) => {
                    props.setFieldValue('dati_indirizzo_spedizione.provincia', e.target.value)
                  }}
                  value={props.values?.dati_indirizzo_spedizione?.provincia}
                  placeholder={t('Seleziona la provincia')}
                  options={province.map((p) => {
                    return {
                      label: p.nome,
                      value: p.sigla,
                    }
                  })}
                ></FormSelect>
              </FormField>
            )}
          {visibleFields.includes('indirizzo_spedizione.cod_fiscale') && (
            <FormField
              label={
                t('Codice fiscale') +
                (requiredFields.includes('indirizzo_spedizione.cod_fiscale') ? ' *' : '')
              }
              status={
                props.touched.dati_indirizzo_spedizione?.cod_fiscale &&
                props.errors.dati_indirizzo_spedizione?.cod_fiscale
                  ? 'error'
                  : props.touched.dati_indirizzo_spedizione?.cod_fiscale && 'success'
              }
              errorMessage={props.errors?.dati_indirizzo_spedizione?.cod_fiscale}
            >
              <FormInput
                placeholder={t('Inserisci il codice fiscale')}
                value={props.values.dati_indirizzo_spedizione.cod_fiscale}
                onBlur={props.handleBlur('dati_indirizzo_spedizione.cod_fiscale')}
                onChange={props.handleChange('dati_indirizzo_spedizione.cod_fiscale')}
              ></FormInput>
            </FormField>
          )}
          {visibleFields.includes('indirizzo_spedizione.partita_iva') && (
            <FormField
              label={
                t('P.IVA') +
                (requiredFields.includes('indirizzo_spedizione.partita_iva') ? ' *' : '')
              }
              status={
                props.touched.dati_indirizzo_spedizione?.partita_iva &&
                props.errors.dati_indirizzo_spedizione?.partita_iva
                  ? 'error'
                  : props.touched.dati_indirizzo_spedizione?.partita_iva && 'success'
              }
              errorMessage={props.errors?.dati_indirizzo_spedizione?.partita_iva}
              infoMessage={t('Inserisci la partita IVA senza spazi né prefisso nazionale')}
            >
              <FormInput
                placeholder={t('Inserisci la p.iva')}
                value={props.values.dati_indirizzo_spedizione?.partita_iva}
                onChange={props.handleChange('dati_indirizzo_spedizione.partita_iva')}
                onBlur={props.handleBlur('dati_indirizzo_spedizione.partita_iva')}
              ></FormInput>
            </FormField>
          )}
          {visibleFields.includes('indirizzo_spedizione.sdi') &&
            props?.values?.is_spedizione_italia && (
              <FormField
                label={
                  t('Codice destinatario SDI') +
                  (requiredFields.includes('indirizzo_spedizione.sdi') ? ' *' : '')
                }
                status={
                  props.touched.dati_indirizzo_spedizione?.sdi &&
                  props.errors.dati_indirizzo_spedizione?.sdi
                    ? 'error'
                    : props.touched.dati_indirizzo_spedizione?.sdi && 'success'
                }
                errorMessage={props.errors?.dati_indirizzo_spedizione?.sdi}
              >
                <FormInput
                  placeholder={t('Inserisci il codice destinatario SDI')}
                  value={props.values.dati_indirizzo_spedizione?.sdi}
                  onBlur={props.handleBlur('dati_indirizzo_spedizione.sdi')}
                  onChange={props.handleChange('dati_indirizzo_spedizione.sdi')}
                ></FormInput>
              </FormField>
            )}
          {visibleFields.includes('indirizzo_spedizione.pec') &&
            props?.values?.is_spedizione_italia && (
              <FormField
                label={t('PEC') + (requiredFields.includes('indirizzo_spedizione.pec') ? ' *' : '')}
                status={
                  props.touched.dati_indirizzo_spedizione?.pec &&
                  props.errors.dati_indirizzo_spedizione?.pec
                    ? 'error'
                    : props.touched.dati_indirizzo_spedizione?.pec && 'success'
                }
                errorMessage={props.errors?.dati_indirizzo_spedizione?.pec}
              >
                <FormInput
                  placeholder={t('Inserisci la PEC')}
                  value={props.values.dati_indirizzo_spedizione?.pec}
                  onBlur={props.handleBlur('dati_indirizzo_spedizione.pec')}
                  onChange={props.handleChange('dati_indirizzo_spedizione.pec')}
                ></FormInput>
              </FormField>
            )}
          {visibleFields.includes('indirizzo_spedizione.telefono') && (
            <FormField
              label={
                t('Telefono') +
                (requiredFields.includes('indirizzo_spedizione.telefono') ? ' *' : '')
              }
              status={
                props.touched.dati_indirizzo_spedizione?.telefono &&
                props.errors.dati_indirizzo_spedizione?.telefono
                  ? 'error'
                  : props.touched.dati_indirizzo_spedizione?.telefono && 'success'
              }
              errorMessage={props.errors?.dati_indirizzo_spedizione?.telefono}
              infoMessage={t(
                'Questo numero di telefono potrà essere utilizzato come riferimento di contatto per la consegna'
              )}
            >
              <FormInput
                placeholder={t('Inserisci il numero di telefono')}
                value={props.values.dati_indirizzo_spedizione?.telefono}
                onBlur={props.handleBlur('dati_indirizzo_spedizione.telefono')}
                onChange={props.handleChange('dati_indirizzo_spedizione.telefono')}
              ></FormInput>
            </FormField>
          )}
          {visibleFields.includes('indirizzo_spedizione.email') && (
            <FormField
              label={
                t('E-mail') + (requiredFields.includes('indirizzo_spedizione.email') ? ' *' : '')
              }
              status={
                props.touched.dati_indirizzo_spedizione?.email &&
                props.errors.dati_indirizzo_spedizione?.email
                  ? 'error'
                  : props.touched.dati_indirizzo_spedizione?.email && 'success'
              }
              errorMessage={props.errors?.dati_indirizzo_spedizione?.email}
              infoMessage={t(
                'A questo indirizzo potremo anche inviarti il codice di tracciamento del tuo pacco'
              )}
            >
              <FormInput
                placeholder={t('Inserisci la mail')}
                value={props.values.dati_indirizzo_spedizione?.email}
                onChange={props.handleChange('dati_indirizzo_spedizione.email')}
                onBlur={props.handleBlur('dati_indirizzo_spedizione.email')}
              ></FormInput>
            </FormField>
          )}
        </div>
      </div>

      {!isFatturaRichiesta && (
        <FormField className="checkout__formfield">
          <FormCheckbox
            label={t('Richiedi fattura')}
            onChange={() => {
              props.setFieldValue('fattura_richiesta', !props.values.fattura_richiesta)
            }}
            checked={props.values.fattura_richiesta}
            onBlur={props.handleBlur('fattura_richiesta')}
          />
        </FormField>
      )}

      {props.values.fattura_richiesta &&
        !hasDifferentRequiredFieldsIndirizzi &&
        isSpedizioneDiversa && (
          <FormField className="step-registrazione__checkbox">
            <FormCheckbox
              label={t('Usa un indirizzo di fatturazione diverso da quello di spedizione')}
              onChange={() =>
                props.setFieldValue('indirizzi_diversi', !props.values.indirizzi_diversi)
              }
              checked={props.values.indirizzi_diversi}
              onBlur={props.handleBlur('indirizzi_diversi')}
            />
          </FormField>
        )}

      {/* Indirizzo di fatturazione */}
      {props.values.indirizzi_diversi && (
        <div>
          <p className="checkout__section-title">{t('Dati di fatturazione')}</p>
          <div className="step-registrazione__fieldsets">
            {visibleFields.includes('indirizzo_fatturazione.nome') && (
              <FormField
                label={
                  t('Nome') + (requiredFields.includes('indirizzo_fatturazione.nome') ? ' *' : '')
                }
                status={
                  props.touched.dati_indirizzo?.nome && props.errors.dati_indirizzo?.nome
                    ? 'error'
                    : props.touched.dati_indirizzo?.nome && 'success'
                }
                errorMessage={props.errors?.dati_indirizzo?.nome}
                infoMessage={t("Indica il nome dell'intestatario della fattura")}
              >
                <FormInput
                  value={props.values.dati_indirizzo.nome}
                  onBlur={props.handleBlur('dati_indirizzo.nome')}
                  onChange={props.handleChange('dati_indirizzo.nome')}
                ></FormInput>
              </FormField>
            )}
            {visibleFields.includes('indirizzo_fatturazione.cognome') && (
              <FormField
                label={
                  t('Cognome') +
                  (requiredFields.includes('indirizzo_fatturazione.cognome') ? ' *' : '')
                }
                status={
                  props.touched.dati_indirizzo?.cognome && props.errors.dati_indirizzo?.cognome
                    ? 'error'
                    : props.touched.dati_indirizzo?.cognome && 'success'
                }
                errorMessage={props.errors?.dati_indirizzo?.cognome}
                infoMessage={t("Indica il cognome dell'intestatario della fattura")}
              >
                <FormInput
                  value={props.values.dati_indirizzo.cognome}
                  onBlur={props.handleBlur('dati_indirizzo.cognome')}
                  onChange={props.handleChange('dati_indirizzo.cognome')}
                ></FormInput>
              </FormField>
            )}
            {visibleFields.includes('indirizzo_fatturazione.ragione_sociale') && (
              <FormField
                label={
                  t('Ragione Sociale') +
                  (requiredFields.includes('indirizzo_fatturazione.ragione_sociale') ? ' *' : '')
                }
                status={
                  props.touched.dati_indirizzo?.ragione_sociale &&
                  props.errors.dati_indirizzo?.ragione_sociale
                    ? 'error'
                    : props.touched.dati_indirizzo?.ragione_sociale && 'success'
                }
                errorMessage={props.errors?.dati_indirizzo?.ragione_sociale}
              >
                <FormInput
                  placeholder={t('Inserisci la ragione sociale')}
                  value={props.values.dati_indirizzo?.ragione_sociale}
                  onChange={props.handleChange('dati_indirizzo.ragione_sociale')}
                  onBlur={props.handleBlur('dati_indirizzo.ragione_sociale')}
                ></FormInput>
              </FormField>
            )}
            {visibleFields.includes('indirizzo_fatturazione.partita_iva') && (
              <FormField
                label={
                  t('P.IVA') +
                  (requiredFields.includes('indirizzo_fatturazione.partita_iva') ? ' *' : '')
                }
                status={
                  props.touched.dati_indirizzo?.partita_iva &&
                  props.errors.dati_indirizzo?.partita_iva
                    ? 'error'
                    : props.touched.dati_indirizzo?.partita_iva && 'success'
                }
                errorMessage={props.errors?.dati_indirizzo?.partita_iva}
                infoMessage={t('Inserisci la partita IVA senza spazi né prefisso nazionale')}
              >
                <FormInput
                  placeholder={t('Inserisci la p.iva')}
                  value={props.values.dati_indirizzo?.partita_iva}
                  onChange={props.handleChange('dati_indirizzo.partita_iva')}
                  onBlur={props.handleBlur('dati_indirizzo.partita_iva')}
                ></FormInput>
              </FormField>
            )}
            {visibleFields.includes('indirizzo_fatturazione.indirizzo') && (
              <FormField
                label={
                  t('indirizzo e n° civico') +
                  (requiredFields.includes('indirizzo_fatturazione.indirizzo') ? ' *' : '')
                }
                status={
                  props.touched.dati_indirizzo?.indirizzo && props.errors.dati_indirizzo?.indirizzo
                    ? 'error'
                    : props.touched.dati_indirizzo?.indirizzo && 'success'
                }
                errorMessage={props.errors?.dati_indirizzo?.indirizzo}
              >
                <FormInput
                  placeholder={t("Inserisci l'indirizzo e il n° civico")}
                  value={props.values.dati_indirizzo?.indirizzo}
                  onChange={props.handleChange('dati_indirizzo.indirizzo')}
                  onBlur={props.handleBlur('dati_indirizzo.indirizzo')}
                ></FormInput>
              </FormField>
            )}
            {visibleFields.includes('indirizzo_fatturazione.citta') && (
              <FormField
                label={
                  t('Citta') + (requiredFields.includes('indirizzo_fatturazione.citta') ? ' *' : '')
                }
                status={
                  props.touched.dati_indirizzo?.citta && props.errors.dati_indirizzo?.citta
                    ? 'error'
                    : props.touched.dati_indirizzo?.citta && 'success'
                }
                errorMessage={props.errors?.dati_indirizzo?.citta}
              >
                <FormInput
                  placeholder={t('Inserisci la città')}
                  value={props.values.dati_indirizzo?.citta}
                  onChange={props.handleChange('dati_indirizzo.citta')}
                  onBlur={props.handleBlur('dati_indirizzo.citta')}
                ></FormInput>
              </FormField>
            )}
            {visibleFields.includes('indirizzo_fatturazione.cap') && (
              <FormField
                label={
                  t('cap') + (requiredFields.includes('indirizzo_fatturazione.cap') ? ' *' : '')
                }
                type="number"
                status={
                  props.touched.dati_indirizzo?.cap && props.errors.dati_indirizzo?.cap
                    ? 'error'
                    : props.touched.dati_indirizzo?.cap && 'success'
                }
                errorMessage={props.errors?.dati_indirizzo?.cap}
              >
                <FormInput
                  placeholder={t('Inserisci il CAP')}
                  value={props.values.dati_indirizzo?.cap}
                  onChange={props.handleChange('dati_indirizzo.cap')}
                  onBlur={props.handleBlur('dati_indirizzo.cap')}
                ></FormInput>
              </FormField>
            )}
            {visibleFields.includes('indirizzo_fatturazione.nazione') && (
              <FormField
                label={
                  t('Paese') +
                  (requiredFields.includes('indirizzo_fatturazione.nazione') ? ' *' : '')
                }
                status={
                  props.touched.dati_indirizzo?.nazione_id &&
                  props.errors.dati_indirizzo?.nazione_id
                    ? 'error'
                    : props.touched.dati_indirizzo?.nazione_id && 'success'
                }
                errorMessage={props.errors?.dati_indirizzo?.nazione_id}
              >
                <FormSelect
                  isSearchable={true}
                  options={
                    nazioni &&
                    nazioni.map((nazione) => {
                      return {
                        label: nazione.alias,
                        value: nazione.id,
                      }
                    })
                  }
                  value={props.values.dati_indirizzo?.nazione_id}
                  placeholder={t('Seleziona il paese')}
                  onChange={(e) => {
                    props.setFieldValue(
                      'is_fatturazione_italia',
                      e.target.label === 'Italia' ? true : false
                    )

                    props.setFieldValue('dati_indirizzo.provincia', null)
                    props.setFieldValue('dati_indirizzo.sdi', null)
                    props.setFieldValue('dati_indirizzo.pec', null)
                    props.setFieldValue('dati_indirizzo.nazione_id', e.target.value)
                  }}
                  onBlur={props.handleBlur('dati_indirizzo.nazione_id')}
                ></FormSelect>
              </FormField>
            )}
            {visibleFields.includes('indirizzo_fatturazione.provincia') &&
              props?.values?.is_fatturazione_italia && (
                <FormField
                  label={
                    t('Provincia') +
                    (requiredFields.includes('indirizzo_fatturazione.provincia') ? ' *' : '')
                  }
                  status={
                    props.values.dati_indirizzo?.provincia === null
                      ? 'error'
                      : props.errors.dati_indirizzo?.provincia
                      ? 'error'
                      : props.touched.dati_indirizzo?.provincia && 'success'
                  }
                  errorMessage={props.errors?.dati_indirizzo?.provincia}
                >
                  <FormSelect
                    onBlur={props.handleBlur('dati_indirizzo.provincia')}
                    isSearchable={true}
                    onChange={(e) => {
                      props.setFieldValue('dati_indirizzo.provincia', e.target.value)
                    }}
                    value={props.values?.dati_indirizzo?.provincia}
                    placeholder={t('Seleziona la provincia')}
                    options={province.map((p) => {
                      return {
                        label: p.nome,
                        value: p.sigla,
                      }
                    })}
                  ></FormSelect>
                </FormField>
              )}
            {visibleFields.includes('indirizzo_fatturazione.cod_fiscale') && (
              <FormField
                label={
                  t('Codice fiscale') +
                  (requiredFields.includes('indirizzo_fatturazione.cod_fiscale') ? ' *' : '')
                }
                status={
                  props.touched.dati_indirizzo?.cod_fiscale &&
                  props.errors.dati_indirizzo?.cod_fiscale
                    ? 'error'
                    : props.touched.dati_indirizzo?.cod_fiscale && 'success'
                }
                errorMessage={props.errors?.dati_indirizzo?.cod_fiscale}
              >
                <FormInput
                  placeholder={t('Inserisci il codice fiscale')}
                  value={props.values.dati_indirizzo.cod_fiscale}
                  onBlur={props.handleBlur('dati_indirizzo.cod_fiscale')}
                  onChange={props.handleChange('dati_indirizzo.cod_fiscale')}
                ></FormInput>
              </FormField>
            )}
            {visibleFields.includes('indirizzo_fatturazione.sdi') &&
              props?.values?.is_fatturazione_italia && (
                <FormField
                  label={
                    t('Codice destinatario SDI') +
                    (requiredFields.includes('indirizzo_fatturazione.sdi') ? ' *' : '')
                  }
                  status={
                    props.touched.dati_indirizzo?.sdi && props.errors.dati_indirizzo?.sdi
                      ? 'error'
                      : props.touched.dati_indirizzo?.sdi && 'success'
                  }
                  errorMessage={props.errors?.dati_indirizzo?.sdi}
                >
                  <FormInput
                    placeholder={t('Inserisci il codice destinatario SDI')}
                    value={props.values.dati_indirizzo?.sdi}
                    onBlur={props.handleBlur('dati_indirizzo.sdi')}
                    onChange={props.handleChange('dati_indirizzo.sdi')}
                  ></FormInput>
                </FormField>
              )}
            {visibleFields.includes('indirizzo_fatturazione.pec') &&
              props?.values?.is_fatturazione_italia && (
                <FormField
                  label={
                    t('PEC') + (requiredFields.includes('indirizzo_fatturazione.pec') ? ' *' : '')
                  }
                  status={
                    props.touched.dati_indirizzo?.pec && props.errors.dati_indirizzo?.pec
                      ? 'error'
                      : props.touched.dati_indirizzo?.pec && 'success'
                  }
                  errorMessage={props.errors?.dati_indirizzo?.pec}
                >
                  <FormInput
                    placeholder={t('Inserisci la PEC')}
                    value={props.values.dati_indirizzo?.pec}
                    onBlur={props.handleBlur('dati_indirizzo.pec')}
                    onChange={props.handleChange('dati_indirizzo.pec')}
                  ></FormInput>
                </FormField>
              )}
            {visibleFields.includes('indirizzo_fatturazione.telefono') && (
              <FormField
                label={
                  t('Telefono') +
                  (requiredFields.includes('indirizzo_fatturazione.telefono') ? ' *' : '')
                }
                status={
                  props.touched.dati_indirizzo?.telefono && props.errors.dati_indirizzo?.telefono
                    ? 'error'
                    : props.touched.dati_indirizzo?.telefono && 'success'
                }
                errorMessage={props.errors?.dati_indirizzo?.telefono}
                infoMessage={
                  props.values.indirizzi_diversi
                    ? null
                    : t(
                        'Questo numero di telefono potrà essere utilizzato come riferimento di contatto per la consegna'
                      )
                }
              >
                <FormInput
                  placeholder={t('Inserisci il numero di telefono')}
                  value={props.values.dati_indirizzo?.telefono}
                  onBlur={props.handleBlur('dati_indirizzo.telefono')}
                  onChange={props.handleChange('dati_indirizzo.telefono')}
                ></FormInput>
              </FormField>
            )}
            {visibleFields.includes('indirizzo_fatturazione.email') && (
              <FormField
                label={
                  t('E-mail') +
                  (requiredFields.includes('indirizzo_fatturazione.email') ? ' *' : '')
                }
                status={
                  props.touched.dati_indirizzo?.email && props.errors.dati_indirizzo?.email
                    ? 'error'
                    : props.touched.dati_indirizzo?.email && 'success'
                }
                errorMessage={props.errors?.dati_indirizzo?.email}
                infoMessage={
                  props.values.indirizzi_diversi
                    ? null
                    : t(
                        'A questo indirizzo potremo anche inviarti il codice di tracciamento del tuo pacco'
                      )
                }
              >
                <FormInput
                  placeholder={t('Inserisci la mail')}
                  value={props.values.dati_indirizzo?.email}
                  onChange={props.handleChange('dati_indirizzo.email')}
                  onBlur={props.handleBlur('dati_indirizzo.email')}
                ></FormInput>
              </FormField>
            )}
          </div>
        </div>
      )}

      {props.values.with_registrazione && (
        <FormField className="step-registrazione__checkbox">
          <FormCheckbox
            label={t('Salva come predefiniti i dati di consegna e i dati di fatturazione')}
            onChange={() =>
              props.setFieldValue('indirizzi_predefiniti', !props.values.indirizzi_predefiniti)
            }
            checked={props.values.indirizzi_predefiniti}
            onBlur={props.handleBlur('indirizzi_predefiniti')}
          />
        </FormField>
      )}

      <p className="step-registrazione__legend">*{t('Campi obbligatori')}</p>
      <Button
        disabled={
          props.errors.dati_indirizzo ||
          props.errors.dati_indirizzo_spedizione ||
          (props.values.initialData ? false : !props.dirty)
        }
        label={t('Conferma dati')}
        variant="primary"
        size="medium"
        onClick={() => setStep(step + 1)}
      />
    </div>
  )
}

export default DatiSpedizioneFatturazione
